import type { CarouselCompatibleAttributes } from '@/types';
import { useMemo } from 'react';

interface UseMobileCarouselSettingsProps {
  attributes: CarouselCompatibleAttributes;
  isViewportMobile: boolean;
}

export const useMobileCarouselSettings = ({ attributes, isViewportMobile }: UseMobileCarouselSettingsProps) => {
  const isMobile = isViewportMobile;

  const {
    // Desktop attributes
    columns,
    shouldScrollHorizontally,
    sliderControlsDisplayType,
    sliderControlsBackgroundColor,
    sliderControlsTextColor,
    sliderControlsBorderColor,

    // Mobile attributes
    mobileShouldScrollHorizontally,
    mobileSliderControlsDisplayType,
    mobileSliderControlsBackgroundColor,
    mobileSliderControlsTextColor,
    mobileSliderControlsBorderColor,
  } = attributes;

  const displayedSettings = useMemo(() => {
    if (isMobile) {
      return {
        columns: '1',
        shouldScrollHorizontally:
          mobileShouldScrollHorizontally !== undefined ? mobileShouldScrollHorizontally : shouldScrollHorizontally,
        sliderControlsDisplayType: mobileSliderControlsDisplayType || sliderControlsDisplayType,
        sliderControlsBackgroundColor: mobileSliderControlsBackgroundColor || sliderControlsBackgroundColor,
        sliderControlsTextColor: mobileSliderControlsTextColor || sliderControlsTextColor,
        sliderControlsBorderColor: mobileSliderControlsBorderColor || sliderControlsBorderColor,
      };
    }

    return {
      columns,
      shouldScrollHorizontally,
      sliderControlsDisplayType,
      sliderControlsBackgroundColor,
      sliderControlsTextColor,
      sliderControlsBorderColor,
    };
  }, [
    isMobile,
    columns,
    shouldScrollHorizontally,
    sliderControlsDisplayType,
    sliderControlsBackgroundColor,
    sliderControlsTextColor,
    sliderControlsBorderColor,
    mobileShouldScrollHorizontally,
    mobileSliderControlsDisplayType,
    mobileSliderControlsBackgroundColor,
    mobileSliderControlsTextColor,
    mobileSliderControlsBorderColor,
  ]);

  return {
    isMobile,
    ...displayedSettings,
  };
};
